import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class HttpInitService {
  constructor(private httpClient: HttpClient) {}

  public postRequest(url: string, data: any) {
    return this.httpClient.post(url, data);
  }

  public postRequestWithProgress(url: string, data: any) {
    return this.httpClient.post(url, data, {
      reportProgress: true,
    });
  }

  public getRequest(url: string) {
    return this.httpClient.get(url);
  }

  public getRequestWithParams(url: string, _params: any) {
    let params = new HttpParams();

    Object.keys(_params).map((key: any) => {
      params = params.append(key, _params[key] != null ? _params[key] : '');
    });

    return this.httpClient.get(url, {
      params: params,
    });
  }
}
